<template>
    <navigation-row v-bind="{ items }" />
</template>

<script>
import { RENTAL_SUBJECT_TYPES } from "@/assets/variables";
import NavigationRow from "../dumb/navigation-row.vue";
const items = [
    { text: "예약 절차 안내", to: "/rental/intro" },
    { text: "장비 사용 신청", to: `/rental/${RENTAL_SUBJECT_TYPES.EQUIPMENTS.value.toLowerCase()}` },
    { text: "공간 사용 신청", to: `/rental/${RENTAL_SUBJECT_TYPES.FACILITIES.value.toLowerCase()}` },
];
export default {
    components: {
        NavigationRow,
    },
    data: () => ({
        items,
    }),
};
</script>

<style></style>
